jQuery.curCSS = jQuery.css;

angular.module('cian.geoInput', ['ui.autocomplete', 'cian.ui.button', 'cian.geoService', 'cian.filter', 'cian.highwaysService'])
.config(["$interpolateProvider", function($interpolateProvider) {
  $interpolateProvider.startSymbol('{$');
  $interpolateProvider.endSymbol('$}');
}]);



// WEBPACK FOOTER //
// ./src/components/geo-input/src/scripts/cian.geo-input.js